import React from 'react';
import PropTypes from "prop-types";
import ComplianceDataTable from "../../../../../components/customBreachBits/compliance/ComplianceDataTable"
import IntlMessages from "../../../../../util/IntlMessages";
import Widget from "../../../../../components/prefabricated/Widget";
import BBIconShieldCheck from "../../../../../assets/bbCustomIcons/BBIconShieldCheck";
import ShowIconShowingIfUserHasAccessToModule
    from "../../../../../components/customBreachBits/info/IconShowingIfCustomerHasAccessToModule";

const Section = (props, {children}) => {

    // const {customers, customerInView} = useSelector(({customer}) => customer);
    // console.log("Customers in BreachBoardContent: ", customers);
    // const customer = getInViewCustomerObject(customerInView, customers);

    const {customerId} = props;

    return (
        <div className={`bb-tab-section`}>
            <div className={"row"}>
                <div className={"col-8"}>
                    <h3>CMMC Practices </h3>
                    <p><strong>Practices</strong> are the 171 controls that encompass the CMMC standard. Each of these Practices must be proven by <strong>Objective Evidence</strong> to exist in your CMMC-certified IT infrastructure, depending on your desired Maturity Level (ML).</p>

                </div>
                <div className={"col-4"}>
                    <ShowIconShowingIfUserHasAccessToModule module={"cmmc"}/>
                </div>
            </div>
            <div className="row">
                <div className={"col-12"}>
                    <Widget>
                            <div className="row">
                                <div className={"col-9"}>
                                    <h2>CMMC Compliance: Enhance your team with BreachBits Automatic Verifications</h2>
                                    <p>The interface below will allow you to explore the 171 Practices, conduct self-assessments, and monitor BreachBits automatic verification and satisfaction activities.  There are also new features coming soon, including the ability to record Third-Party assessments and import and export data.  We'd love your feedback or to hear about the types of funcitonality that you'd like to see in this feature. <a href={"mailto:support@breachbits.com"}>Send us feedback to support@breachbits.com</a>.</p>
                                </div>
                                <div className={"col-3 text-center"}>
                                    <BBIconShieldCheck style={{fontSize: 130}} />
                                </div>
                        </div>
                    </Widget>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <ComplianceDataTable
                        customerId={customerId}
                        complianceStandardId={"b16947c0-b1e8-46f2-a6f5-6fc2057a74cf"}
                        tableTitle={<IntlMessages id={"controls.cmmc.tableTitle"}/>}
                        tableTip={<IntlMessages id={"controls.cmmc.tipText"}/>}
                    />
                </div>
            </div>


        </div>
    )
};

Section.propTypes = {
    customerId: PropTypes.string,
};

export default Section;

